/**
 * BarrierBoss Fast Quantity Buttons
 * Optimistically updates quantity display on click without waiting for AJAX.
 * The theme's own JS still handles the actual cart update.
 */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.QuantitySelector__Button');
    if (!btn) return;

    var selector = btn.closest('.QuantitySelector');
    if (!selector) return;

    var input = selector.querySelector('.QuantitySelector__CurrentQuantity');
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;
    var newQty = parseInt(btn.dataset.quantity, 10);

    // If data-quantity not set, figure it out from +/-
    if (isNaN(newQty)) {
      var href = btn.getAttribute('href') || '';
      var match = href.match(/quantity=(\d+)/);
      if (match) newQty = parseInt(match[1], 10);
    }

    if (!isNaN(newQty) && newQty >= 0) {
      // Instantly update the displayed value
      input.value = newQty;

      // Quick visual feedback
      input.style.transition = 'none';
      input.style.color = '#ff580d';
      setTimeout(function() {
        input.style.transition = 'color 0.3s';
        input.style.color = '';
      }, 200);
    }
  }, true); // capture phase to run before theme JS

  // BB_QTY_SELECT_ON_FOCUS 2026-07-20: the cart qty field does NOT select its
  // contents on focus, so a user who clicks in and types "200" gets "5200" (their
  // digits appended to the existing quantity). Select-all on focus so typing REPLACES
  // — the natural "enter my quantity" behaviour. Pairs with the template fix that
  // removed the trailing space (which had made parseInt() truncate and reset).
  document.addEventListener('focusin', function(e) {
    var input = e.target.closest && e.target.closest('.QuantitySelector__CurrentQuantity');
    if (!input) return;
    // defensive: strip any stray whitespace, then select all
    if (/\s/.test(input.value)) input.value = input.value.replace(/\s+/g, '');
    setTimeout(function(){ try { input.select(); } catch (_) {} }, 0);
  });
})();
